define('rating',['tooltip-notifier'], function(tooltipNotifier) {
	function rate() {
		var button = $(this);
		if (button.parent().hasClass('preview')) {
			return;
		}

		var review = 0;
		var postID = button.data('post-id');
		
		if (button.hasClass('upvote') && !button.hasClass('selected'))
			review = 1;
		
		if (button.hasClass('downvote') && !button.hasClass('selected'))
			review = -1;
	
		$.ajax({
	        type: "POST",
	        url: "/posts/" + postID + '/rate',
			data: {review: review}
		}).done(function (data) {
			if (data.success)
				onRated(data, review);
			else
				tooltipNotifier.showError(button, 'Bewerten fehlgeschlagen. Du kannst deine eigenen Beiträge nicht bewerten.');
		}).fail(function (xhr) {
			tooltipNotifier.showError(button, 'Bewerten fehlgeschlagen. Bitte versuche es erneut.', xhr);
		});
	}
	
	function onRated(data, review) {
		$('.upvote').html(data.new_upvotes);
		$('.downvote').html(data.new_downvotes);
		
		var downs = Math.floor((data.new_downvotes * 100) / (data.new_upvotes + data.new_downvotes));
		var ups = 100 - downs;
		
		var up_bar = $('.rating-bar').find('.ups').first();
		var down_bar = $('.rating-bar').find('.downs').first();
		
		// change rating bar
		if (!up_bar.length && (data.new_upvotes || data.new_downvotes)) { // first vote
			$('.rating-bar').find('.no-votes').remove();
			$('.rating-bar').append($('<span>').addClass('ups').css('width', ups + '%'));
			$('.rating-bar').append($('<span>').addClass('downs').css('width', downs + '%'));
		} else if (data.new_upvotes || data.new_downvotes) { // still votes there
			up_bar.css('width', ups + '%');
			down_bar.css('width', downs + '%');
		} else { // no votes anymore
			$('.rating-bar').empty();
			$('.rating-bar').append($('<span>').addClass('no-votes'));
		}
		
		// set selected class
		$('.thumb-rating').find('.upvote, .downvote').removeClass('selected');
		
		if (review == 1)
			$('.thumb-rating').find('.upvote').addClass('selected');
		
		if (review == -1)
			$('.thumb-rating').find('.downvote').addClass('selected');
	}
	
	return {
		init: function() {
			$('.upvote, .downvote').click(rate);
		}
	};
});

